import axios from 'axios';
import {checkErrors} from './errors';

export const LOGIN_REQUESTED = 'account/LOGIN_REQUESTED';
export const LOGIN_FINISHED = 'account/LOGIN_FINISHED';
export const LOGIN = 'account/LOGIN';
export const SET_TOKEN = 'account/SET_TOKEN';
export const REMOVE_TOKEN = 'account/REMOVE_TOKEN';
export const LOGOUT_REQUESTED = 'account/LOGOUT_REQUESTED';
export const LOGOUT = 'account/LOGOUT';

export const PUSHDATA_REQUESTED = 'account/PUSHDATA_REQUESTED';
export const PUSHDATA_FINISHED = 'account/PUSHDATA_FINISHED';

const getSubscriptionID = () => {
  let subscriptionID = null;
  try {
    subscriptionID = JSON.parse(atob(localStorage.getItem(window.token).split('.')[1])).subscription;
  } catch (e) {

  }
  return subscriptionID;
}

const getSubscription = () => {
  let subscription = null;
  try {
    subscription = JSON.parse(atob(localStorage.getItem(window.token).split('.')[1])).subscription_name;
  } catch (e) {

  }
  return subscription;
}

const getUsername = () => {
  let subscription = null;
  try {
    subscription = JSON.parse(atob(localStorage.getItem(window.token).split('.')[1])).username;
  } catch (e) {

  }
  return subscription;
}

const getRole = () => {
  let role = null;
  try {
    role = JSON.parse(atob(localStorage.getItem(window.token).split('.')[1])).user_type;
  } catch (e) {

  }
  return role;
}

const initialState = {
  loggedIn: localStorage.getItem(window.token) ? true : false,
  token: null,
  subscriptionID: getSubscriptionID(),
  subscription: getSubscription(),
  username: getUsername(),
  role: getRole(),
  isLoggingIn: false,
  isLoggingOut: false,
  message: null,
  isPushingData: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
  case LOGIN_REQUESTED:
    return {
      ...state,
      isLoggingIn: true,
      message: null
    };

  case LOGIN_FINISHED:
    return {
      ...state,
      isLoggingIn: false,
      message: action.message
    };

  case LOGIN:
    return {
      ...state,
      loggedIn: true,
      message: null,
      isLoggingIn: action.token
    };
  
  case SET_TOKEN:

    localStorage.setItem(window.token, action.token);

    return {
      ...state,
      token: action.token,
      // subscription: getSubscription(),
      subscriptionID: getSubscriptionID(),
      subscription: getSubscription(),
      username: getUsername(),
      role: getRole(),
    };

  case REMOVE_TOKEN:

    localStorage.removeItem(window.token);

    return {
      ...state,
      token: action.token
    };


  case LOGOUT_REQUESTED:
    return {
      ...state,
      isLoggingOut: true
    };

  case LOGOUT:
    state = null;

    return {
      state,
      loggedIn: false,
      isLoggingOut: false
    };

  case PUSHDATA_REQUESTED:
    return {
      ...state,
      isPushingData: true,
    };

  case PUSHDATA_FINISHED:
    return {
      ...state,
      isLoggingIn: false,
    };

  default:
    return state;
  }
};

export const checkLoggedIn = () => {

};

export const loginAsync = (user_username, user_password) => {
  return dispatch => {
    dispatch({
      type: LOGIN_REQUESTED
    });

    const formData = new FormData();
    formData.append('data', JSON.stringify({ user_username, user_password }));

    axios.post(`${window.endpoint}/users/login`, formData ).then(response => {
      
      if(response.data.status){
        // dispatch({ type: SET_TOKEN, token: "JWT eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImFkbWluYW5nbGljYW5jaHVyY2giLCJzdWJzY3JpcHRpb24iOjQsInVzZXJfdHlwZSI6MSwiaWF0IjoxNTMwMTY5ODMxLCJleHAiOjE1MzA2ODgyMzF9.M8SxGxzF2d1WorMNuZErNevK7X7K5dgdhzFqzyZsFfQ" });
        dispatch({ type: SET_TOKEN, token: response.data.token });
        dispatch({ type: LOGIN });
      } else {
        dispatch({ type: LOGIN_FINISHED, message: response.data.message });
        
      }
    })
      .catch((err) => {
        dispatch({ type: LOGIN_FINISHED, message: err.response.data.message });
      });

  };
};

export const logoutAsync = () => {
  return dispatch => {
    dispatch({
      type: LOGOUT_REQUESTED
    });

    return setTimeout(() => {
      dispatch({ type: LOGOUT });
      dispatch({ type: REMOVE_TOKEN });
    }, 3000);
  };
};

export const pushData = (cb) => {
  return (dispatch, getState) => {

    const accountState = getState().account;

    dispatch({
      type: PUSHDATA_REQUESTED
    });

    axios.get(`${window.endpoint}/exports/${accountState.subscriptionID}`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {
      
      dispatch({
        type: PUSHDATA_FINISHED
      });

      if (cb instanceof Function) { cb(response); }
      
    }).catch((error) => {
      checkErrors(error);
    });
  };
};


// WEBPACK FOOTER //
// ./src/reducers/account.js